<template>
  <input class="w-full py-3 bg-transparent font-body text-body-m-mobile md:text-body-m text-black border-b border-b-black hover:border-blue-400 placeholder:text-gray-500 outline-none"
  />
</template>

